setTimeout(function () {
  if ("" == window.location.hash) {
    window.location.hash = "#celebrating";
  }
}, 3000);
const observerOptions = {
  root: null,
  rootMargin: "0px",
  threshold: 0.8,
};

function observerCallback(entries, observer) {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      entry.target.classList.add("fadeIn");
    }
  });
}
const fader = new IntersectionObserver(observerCallback, observerOptions);
const fadeElms = document.querySelectorAll(".fade");
fadeElms.forEach((el) => fader.observe(el));

function cb(entries, fader) {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      entry.target.classList.add("slide-in");
    }
  });
}
const ob2 = new IntersectionObserver(cb, observerOptions);
const slides = document.querySelectorAll(".slider");
slides.forEach((el) => ob2.observe(el));

document.querySelectorAll(".map-farm").forEach(function (el) {
  el.addEventListener("mouseover", function (e) {
    handleFarmMap(el);
  });

  el.addEventListener("focus", function (e) {
    handleFarmMap(el);
  });
});

function handleFarmMap(el) {
  const selected = document.querySelector(".clickable-farms .show");
  const farm = el.dataset.farm;

  document.querySelectorAll(".map-farm").forEach(function (el2) {
    el2.setAttribute("aria-selected", false);
  });

  if (selected && selected.dataset.farm != farm) {
    selected.classList.remove("show");
    el.setAttribute("aria-selected", true);
    document.querySelector(".map-farm.show").classList.remove("show");
    document.querySelector(".clickable-farms ." + farm).classList.add("show");
    document.querySelector(".map-farm." + farm).classList.add("show");
    let img = document.querySelector(".map-farms img");
    img.src = "https://loudonco.com/img/map-" + farm + ".png";
  }
}

const opts = {
  root: null,
  rootMargin: "0px",
  threshold: 0.8,
};
function sidescroll(entries, observer) {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      entry.target.addEventListener("wheel", function horizontal_scroll(evt) {
        if (evt.deltaY > 0 || evt.deltaY < 0) {
          let left = entry.target.scrollLeft;
          entry.target.scrollLeft += evt.deltaY;
          if (left == entry.target.scrollLeft && evt.deltaY > 0) {
            entry.target.removeEventListener("wheel", horizontal_scroll, false);
          }
          if (left == 0 && evt.deltaY < 0) {
            entry.target.removeEventListener("wheel", horizontal_scroll, false);
          }
          evt.preventDefault();
        }
      });
    }
  });
}
const ob3 = new IntersectionObserver(sidescroll, opts);
const side_scrollers = document.querySelectorAll(".side-scroll");
side_scrollers.forEach((el) => ob3.observe(el));

$("body").scroll(function () {
  if ($("body").scrollTop() > 150) {
    $(".header__wrapper").addClass("shrink");
  } else {
    $(".header__wrapper").removeClass("shrink");
  }
});
